var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x30_1._Facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.657,
    height: 38.295,
    viewBox: "0 0 20.657 38.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_11_",
    d: "M34.151,31.716H29.407c-.767,0-1.007-.288-1.007-1.007v-5.8c0-.767.288-1.007,1.007-1.007h4.745V19.686a10.646,10.646,0,0,1,1.294-5.416,7.953,7.953,0,0,1,4.266-3.547A10.664,10.664,0,0,1,43.4,10.1h4.7c.671,0,.959.288.959.959v5.464c0,.671-.288.959-.959.959-1.294,0-2.588,0-3.882.048a1.731,1.731,0,0,0-1.965,1.965c-.048,1.438,0,2.828,0,4.314h5.56c.767,0,1.054.288,1.054,1.054v5.8c0,.767-.24,1.007-1.054,1.007h-5.56V47.293c0,.815-.24,1.1-1.1,1.1H35.158c-.719,0-1.007-.288-1.007-1.007V31.716Z",
    transform: "translate(-28.4 -10.1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.49c509df769ddce5e55072daf39be7fb.svg";
export { ForwardRef as ReactComponent };